<template>
  <FlexColumn :space="0" class="mt-1">
    <Label text="保存した検索条件" class="mb-1" bold />
    <FlexRow :space="0" wrap style="gap: 8px 3px">
      <Tooltip
          v-for="(conditionSet, index) in searchConditionSets"
          :key="index"
          :message="conditionSet.name"
          open-delay="700"
      >
        <Chip
            :color="conditionSet.id === selectedConditionSetId ? undefined : '#555'"
            size="small"
            :outlined="conditionSet.id !== selectedConditionSetId"
            link
            close
            closeIcon="mdi-settings"
            rectangle
            @click="$emit('select', conditionSet)"
            @close="handleClose(conditionSet)"
        >
          {{truncate(conditionSet.name, 22)}}
        </Chip>
      </Tooltip>
    </FlexRow>
    <ApplicantSearchConditionsSettingDialog
        :open="conditions !== undefined"
        :conditions="conditions"
        @close="conditions = undefined"
    />
  </FlexColumn>
</template>

<script>
import FlexColumn from "@/components/atoms/FlexColumn";
import Chip from "@/components/atoms/Chip";
import Label from "@/components/atoms/Label";
import {mapGetters} from "vuex";
import ApplicantSearchConditionsSettingDialog from "@/components/organisms/ApplicantSearchConditionsSettingDialog";
import Tooltip from "../atoms/Tooltip";
import ComponentMixin from "../ComponentMixin";
import FlexRow from '../atoms/FlexRow'

export default {
  mixins: [ComponentMixin],
  name: "ApplicantSearchConditionsSets",
  components: { FlexRow, Tooltip, ApplicantSearchConditionsSettingDialog, Label, Chip, FlexColumn},
  data() {
    return {
      conditions: undefined
    }
  },
  computed: {
    ...mapGetters('chatRequests', ['searchConditionSets', 'selectedSearchConditionSet']),
    selectedConditionSetId() {
      if (this.selectedSearchConditionSet) {
        return this.selectedSearchConditionSet.id
      }
      return undefined
    }
  },
  methods: {
    handleClose(conditionSet) {
      this.conditions = conditionSet
    },
  }
}
</script>

<style scoped>

</style>